import { Component, OnInit } from '@angular/core';

import { AuthorizationService } from '../services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    idleTime: number = 3600000;
    time: any;
    username: string;

    constructor(public authorizationService: AuthorizationService) { }

    ngOnInit(): void {
        // window events
        window.addEventListener('load', () => { this.resetTimer(); }, { once: false, passive: true });

        // DOM Events — use 'wheel' and 'touchmove' instead of 'scroll' because
        // scroll does not bubble; wheel and touchmove do, so they fire even when
        // the inner overflow container is scrolled.
        document.addEventListener('wheel', () => { this.resetTimer(); }, { once: false, passive: true });
        document.addEventListener('click', () => { this.resetTimer(); }, { once: false, passive: true });
        document.addEventListener('keydown', () => { this.resetTimer(); }, { once: false, passive: true });
        document.addEventListener('mousedown', () => { this.resetTimer(); }, { once: false, passive: true });
        document.addEventListener('mousemove', () => { this.resetTimer(); }, { once: false, passive: true });
        document.addEventListener('touchstart', () => { this.resetTimer(); }, { once: false, passive: true });
        document.addEventListener('touchmove', () => { this.resetTimer(); }, { once: false, passive: true });
    }

    resetTimer(): void {
        const inactiveMessage = `You have been logged out due to inactivity!`;
        clearTimeout(this.time);

        this.time = setTimeout(() => {
            alert(inactiveMessage);
            this.authorizationService.login();
        }, this.idleTime);
    }
}
